import React, {useContext} from 'react';
import {IntlProvider} from 'react-intl';

import AppLocale from '../../shared/localization';
import AppContext from './AppContext';
import AppContextPropsType from '../../types/AppContextPropsType';

const LocaleProvider: React.FC<React.PropsWithChildren> = (props) => {
  const {locale} = useContext<AppContextPropsType>(AppContext);
  const currentAppLocale = AppLocale[locale.locale];

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      defaultLocale='fr'
      messages={currentAppLocale.messages}>
      {props.children}
    </IntlProvider>
  );
};

export default LocaleProvider;
